import { StudentMapping } from 'models';

export class FeeCategory {
    feeCategory: string;
    studentProfile: StudentMapping;
    isEditable: boolean;
}
